import { render, staticRenderFns } from "./gl-reporting-group-2.vue?vue&type=template&id=1548e26d&"
import script from "./gl-reporting-group-2.vue?vue&type=script&lang=js&"
export * from "./gl-reporting-group-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports